import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Col, Container, Row, CardText, BreadcrumbItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import "./style.scss";

const SkeletonComponent = {
	HomeCompounds: () => {
		return (
			<>
				{Array(4)
					.fill()
					.map((item, index) => (
						<Col lg={3} md={5} sm={6} key={index}>
							<SkeletonTheme>
								<Skeleton height={180} className="mb-1" />
								<h2>
									<Skeleton height={36} width={`70%`} />
								</h2>
								<Skeleton width={`65%`} height={30} />
								<br />
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
							</SkeletonTheme>
						</Col>
					))}
			</>
		);
	},
	CompoundDetails: (props) => {
		const { t } = useTranslation();
		return (
			<Container fluid className="px-lg-5 px-3 pb-5 pt-10rem websitPages">
				{/* <ol className="breadcrumb ps-0 mb-2">
					<BreadcrumbItem
						style={{ cursor: "pointer" }}
						onClick={() => {
							props.history.push("/");
						}}>
						{t("home")}
					</BreadcrumbItem>
					<BreadcrumbItem
						style={{ cursor: "pointer" }}
						onClick={() => props.history.goBack()}>
						{t("results")}
					</BreadcrumbItem>
					<BreadcrumbItem active>{t("details")}</BreadcrumbItem>
				</ol> */}
				<p
					className="page-title"
					dangerouslySetInnerHTML={{
						__html: t("compound details title"),
					}}></p>
				<Row>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={130}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={200} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={200}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={130} width={`100%`} />
					</Col>
				</Row>
				<Row>
					<h2 className="text-primary mt-4">{t("matching units")}</h2>
					<Row>
						{Array(4)
							.fill()
							.map((item, index) => (
								<Col lg={3} md={5} sm={6} key={index} className="mb-2">
									<SkeletonTheme>
										<Skeleton height={180} className="mb-1" />
										<h2>
											<Skeleton height={36} width={`100%`} />
										</h2>
										<h5>
											<Skeleton height={36} width={`60%`} />
										</h5>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`20%`}
											height={25}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`20%`}
											height={25}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`20%`}
											height={25}
										/>
										<br />
										<Skeleton className="mx-1" width={`100%`} height={25} />
										<br />
										<Skeleton
											inline={true}
											className="mx-1"
											width={`30%`}
											height={40}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`30%`}
											height={40}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`30%`}
											height={40}
										/>
									</SkeletonTheme>
								</Col>
							))}
					</Row>
					<Col md={12} className="mx-1 mt-4">
						<h2 className="text-primary mt-4">{t("interactive mode")}</h2>
						<Skeleton height={500} width={`100%`} />
					</Col>
					<Col md={12} className="mx-1 mt-4">
						<h2 className="text-primary mt-4">{t("location")}</h2>
						<Skeleton height={500} width={`100%`} />
					</Col>
				</Row>
			</Container>
		);
	},
	ProprtyDetails: (props) => {
		const { t } = useTranslation();

		return (
			<Container fluid className="px-lg-5 px-3 pb-5 pt-10rem websitPages">
				<p
					className="page-title"
					dangerouslySetInnerHTML={{
						__html: t("Property Details"),
					}}></p>
				<Row>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={130}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={200} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={200}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={130} width={`100%`} />
					</Col>
				</Row>
			</Container>
		);
	},
	ProprtyBuyDetails: (props) => {
		const { t } = useTranslation();

		return (
			<Container fluid className="websitPages pt-10rem px-lg-5 px-3 pb-5">
				<p
					className="font-size-32 text-primary"
					dangerouslySetInnerHTML={{
						__html: t("Property Process"),
					}}></p>
				<Row>
					<SkeletonTheme>
						<Col md={12}>
							<Skeleton height={150} className="mb-1" />
						</Col>
						<Col md={6} className="mt-3">
							<Skeleton height={100} className="mb-3" />
						</Col>
						<Col md={6} className="mt-3">
							<Skeleton height={100} className="mb-3" />
						</Col>
					</SkeletonTheme>
				</Row>
			</Container>
		);
	},
	ResaleDetails: (props) => {
		const { t } = useTranslation();

		return (
			<Container fluid className="px-lg-5 px-3 pb-5 pt-10rem websitPages">
				{/* <ol className="breadcrumb ps-0 mb-2">
					<BreadcrumbItem
						style={{ cursor: "pointer" }}
						onClick={() => {
							props.history.push("/");
						}}>
						{t("home")}
					</BreadcrumbItem>
					<BreadcrumbItem
						style={{ cursor: "pointer" }}
						onClick={() => {
							props.history.goBack();
						}}>
						{t("results")}
					</BreadcrumbItem>
					<BreadcrumbItem active>{t("resale details")}</BreadcrumbItem>
				</ol> */}
				<p
					className="page-title"
					dangerouslySetInnerHTML={{
						__html: t("Resale Details"),
					}}></p>
				<Row>
					<SkeletonTheme>
						<Col md={3}>
							<Skeleton height={350} className="mb-1" />
						</Col>
						<Col md={3}>
							<Row>
								{" "}
								<Skeleton height={170} className="mb-3" />
							</Row>
							<Row>
								{" "}
								<Skeleton height={160} className="mb-1" />
							</Row>
						</Col>
						<Col md={3}>
							<Skeleton height={350} className="mb-1" />
						</Col>
						<Col md={3}>
							<Row>
								{" "}
								<Skeleton height={170} className="mb-3" />
							</Row>
							<Row>
								{" "}
								<Skeleton height={160} className="mb-1" />
							</Row>
						</Col>
						<Row className=" p-0 d-flex justify-content-between">
							<Col md={8} className="my-2 mx-3">
								<Skeleton inline={true} width={`20%`} height={30} />
								<h2 className="my-4">
									<Skeleton height={36} width={`70%`} />
								</h2>
								<Skeleton inline={true} width={`50%`} height={30} />
							</Col>
							<Col md={3} className="my-2  p-0">
								<Skeleton inline={true} width={`100%`} height={100} />
							</Col>
							<Col md={8}></Col>
							<Col md={4}></Col>
							<Col md={12} className="mx-1">
								<h2 className="text-primary">{t("Property Amenities")}</h2>
								<Skeleton height={200} width={`100%`} />
							</Col>
							<Col md={12} className="mx-1">
								<h2 className="text-primary">{t("payment plans")}</h2>
								<Skeleton height={300} width={`100%`} />
							</Col>
							<Col md={12} className="mx-1">
								<h2 className="text-primary">{t("location")}</h2>
								<Skeleton height={500} width={`100%`} />
							</Col>
						</Row>
					</SkeletonTheme>
				</Row>
			</Container>
		);
	},
	HomeResales: () => {
		return (
			<>
				{Array(4)
					.fill()
					.map((item, index) => (
						<Col lg={3} md={5} sm={6} key={index} className="mb-2">
							<SkeletonTheme>
								<Skeleton height={180} className="mb-1" />
								<h2>
									<Skeleton height={36} width={`100%`} />
								</h2>
								<h5>
									<Skeleton height={36} width={`60%`} />
								</h5>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<br />
								<Skeleton className="mx-1" width={`100%`} height={25} />
								<br />
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
							</SkeletonTheme>
						</Col>
					))}
			</>
		);
	},
	Compounds: () => {
		return (
			<>
				{Array(9)
					.fill()
					.map((item, index) => (
						<Col lg={4} md={6} sm={6} key={index}>
							<SkeletonTheme>
								<Skeleton height={180} className="mb-1" />
								<h2>
									<Skeleton height={36} width={`70%`} />
								</h2>
								<Skeleton width={`65%`} height={30} />
								<br />
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
							</SkeletonTheme>
						</Col>
					))}
			</>
		);
	},
	Resales: () => {
		return (
			<>
				{Array(9)
					.fill()
					.map((item, index) => (
						<Col lg={4} md={6} sm={6} key={index} className="mb-2">
							<SkeletonTheme>
								<Skeleton height={180} className="mb-1" />
								<h2>
									<Skeleton height={36} width={`100%`} />
								</h2>
								<h5>
									<Skeleton height={36} width={`60%`} />
								</h5>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<br />
								<Skeleton className="mx-1" width={`100%`} height={25} />
								<br />
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
							</SkeletonTheme>
						</Col>
					))}
			</>
		);
	},
	Interactive: () => {
		return (
			<>
				<SkeletonTheme>
					<Skeleton height="30rem" className="mt-3" />
				</SkeletonTheme>
			</>
		);
	},
};

export default SkeletonComponent;
